import axios from "axios";

export const setDiscordEnabled = async (email, discordEnabled) => {
    const accessToken = window.localStorage.getItem('access_token');

    const res = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/set_discord_enabled?email=${email}&discord_enabled=${discordEnabled}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    })).data

    return res
}